module.exports = __webpack_public_path__ + "static/media/T2.c2165175.mp4";